/** @format */

import { enterOrExit } from '@/api/exception-management/index';
import { reviseFromMap } from '@/types/financial-management/dictionaries';
import { dictChannelTypeMap } from '@/types/parking-lot-management/dictionaries';
import Utils from '@root/utils/common';
import * as _ from 'lodash';
export default {
  onTableData(
    o: {
      totalAmount: any;
      paidAmount: any;
      discountAmount: any;
      unpaidAmount: any;
      cancelAmount: any;
      pkOrderId: string;
      parkName: string;
      isTotalRow: boolean;
    }[],
    resData: { total: any }
  ) {
    const totals = resData.total;

    if (totals != null) {
      o.push({
        totalAmount: totals.totalAmounts,
        paidAmount: totals.paidAmounts,
        discountAmount: totals.specialAmounts,
        unpaidAmount: totals.unpaidAmounts,
        cancelAmount: totals.discountAmounts,
        pkOrderId: Symbol().toString(),
        parkName: '合计',
        isTotalRow: true
      });
    }

    // console.log('on table data invoked', resData)
    return o;
  },
  onDetail(o: any) {
    //获取通道类型
    function getChannelName(value: any) {
      const channelTypeOptions = Utils.toLabelVal(dictChannelTypeMap) || [];
      const a = _.filter(channelTypeOptions, function(o) {
        return o.value == value;
      });
      return a[0].label || '--';
    }
    //获取操作来源
    function getreviseFromName(value: any) {
      const reviseFromList = Utils.toLabelVal(reviseFromMap) || [];
      const a = _.filter(reviseFromList, function(o) {
        return o.value == value;
      });
      return a[0].label || '--';
    }
    function toOrderDetail(basicInfo: { fields: any[]; data: { [x: string]: any } }, prop: string) {
      const orderIdNode = basicInfo.fields.find((item: { prop: string }) => item.prop === prop);
      if (!orderIdNode) {
        return false;
      }
      orderIdNode.render = (
        c: (
          arg0: string,
          arg1: {
            domProps: {
              innerHTML: string;
            };
            on: { click: () => void };
            style: { color: string; cursor: string };
          }
        ) => any
      ) => {
        return c('div', {
          domProps: {
            innerHTML: basicInfo.data[orderIdNode.prop]
          },
          on: {
            click: async () => {
              if (basicInfo.data[orderIdNode.prop]) {
                try {
                  const { data } = await enterOrExit({
                    orderId: basicInfo.data[orderIdNode.prop]
                  });
                  // @ts-ignore
                  if (!data) return this.$message.error('暂无停车记录详情');
                  //在场
                  if (data == '00') {
                    //出场
                    // @ts-ignore
                    self.onDetailDialogCancel();
                    // @ts-ignore
                    self.$router.push({
                      name: 'ENTER_CAR_DETAIL',
                      params: {
                        parkId: basicInfo.data['parkId'],
                        pkOrderId: basicInfo.data[orderIdNode.prop],
                        from: '01'
                      }
                    });
                  }
                  if (data == '01') {
                    //出场
                    // @ts-ignore
                    self.onDetailDialogCancel();
                    // @ts-ignore
                    self.$router.push({
                      name: 'PARKING_RECORD_DETAIL',
                      params: {
                        parkId: basicInfo.data['parkId'],
                        pkOrderId: basicInfo.data[orderIdNode.prop],
                        from: '01'
                      }
                    });
                  }
                } catch (e) {
                  // @ts-ignore
                  this.$message.error((e && e.msg) || '系统异常请稍后再试');
                }
              }
            }
          },
          style: {
            color: '#ff9f08',
            cursor: 'pointer'
          }
        });
      };
    }
    // @ts-ignore
    this.reviewDescriptionOfDialog = '';
    const basicInfo = o['基本信息'];
    const self = this;
    const tempFields = basicInfo.fields;
    basicInfo.fields = tempFields.filter(
      (item: { label: string }) =>
        !item.label.startsWith('审核') && !(item.label.includes('收') || item.label.includes('金额'))
    );
    console.log(' basicInfo.fields', basicInfo.fields);
    let reviewInfo;
    basicInfo.data.afterCarType = '- 小型车 大型车'.split(' ')[basicInfo.data.afterCarType - 0];
    basicInfo.data.beforeCarType = '- 小型车 大型车'.split(' ')[basicInfo.data.beforeCarType - 0];
    basicInfo.data.channelType = getChannelName(basicInfo.data.channelType);
    basicInfo.data.reviseFrom = getreviseFromName(basicInfo.data.reviseFrom);
    basicInfo.data.revisePlateNum = String(basicInfo.data.revisePlateNum || '0');
    // @ts-ignore
    if ('DETAIL' == this.detailDialogType) {
      reviewInfo = {
        fields: tempFields.filter((item: { label: string }) => item.label.startsWith('审核')),
        data: basicInfo.data
      };
    }
    // @ts-ignore
    if ('REVIEW' == this.detailDialogType) {
      reviewInfo = {
        fields: [
          {
            label: '审核意见',
            render(
              c: (
                arg0: string,
                arg1: {
                  attrs: { placeholder: string };
                  style: { 'max-width': string; width: string };
                  on: { change(e: any): void };
                },
                arg2: string
              ) => any
            ) {
              return c(
                'a-textarea',
                {
                  attrs: {
                    placeholder: '请输入审核意见'
                  },
                  style: {
                    'max-width': '250%',
                    width: '250%'
                  },

                  on: {
                    change(e: { target: { value: any } }) {
                      // @ts-ignore
                      self.reviewDescriptionOfDialog = e.target.value;
                      console.log('this is on change--:', e.target.value);
                    }
                  }
                },
                ''
              );
            }
          }
        ],
        data: basicInfo.data
      };
    }
    // @ts-ignore
    self.getImgRenderFunInDetailDialog.call(self, basicInfo, 'img');
    toOrderDetail.call(self, basicInfo, 'orderId');
    return {
      ...o,

      // 收费信息: {
      //   data: basicInfo.data,
      //   fields: tempFields.filter(item => item.label.includes('收') || item.label.includes('金额')),
      // },
      审核信息: reviewInfo
    };
  },
  // @ts-ignore
  onSearch(o: any) {
    return {
      parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
      reviseFrom: o.reviseFrom instanceof Array ? o.reviseFrom.join(',') : o.reviseFrom,
      // @ts-ignore
      currPage: this.current,
      revisePlateNum: o.revisePlateNum ? Number(o.revisePlateNum) : '',
      // plate: o.adapterDataForViewModel.plateHead + o.adapterDataForViewModel.plateTail,
      // userId: '',
      // @ts-ignore
      pageSize: this.pageSize
    };
  }
};
